const COOKIES = {
  PUBLIC_INVITE_DATA: "publicInviteData",
  DEBUG_GA_ON: "DebugGaOn",
};

Object.freeze(COOKIES);

export { COOKIES };
